module.exports = __webpack_public_path__ + "static/kitchen-white-3211934b4e17e7bbfb98bd9cea2f994d.jpg";